import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { ButtonLink, ButtonOutlineLarge } from '@styled';
import { GlobalModalContext } from '@context/globalModalContext';

export const useSuccessListingModal = () => {
    const [, setIsModalOpen, setModalChildren] = useContext(GlobalModalContext);

    const openModal = id => {
        setModalChildren(SuccessListing({ closeModal: () => setIsModalOpen(false), id }));
        setIsModalOpen(true);
    };

    return { openModal };
};

const SuccessListing = ({ closeModal, id }) => (
    <div>
        <h3 className="my-3">Success</h3>
        <p>Your properties are created. Edit and enhance property listings with additional details.</p>
        <div className="d-flex mt-2">
            <ButtonLink href={`/my-icsc/properties/${id}/edit`} className="mr-3">
                Enhance my listing
            </ButtonLink>
            <ButtonOutlineLarge onClick={closeModal}>Done</ButtonOutlineLarge>
        </div>
    </div>
);

SuccessListing.propTypes = {
    closeModal: PropTypes.func,
    id: PropTypes.string,
};

export default SuccessListing;
